import {
  RESEND_ENTERPRISE_INVITE,
  RESEND_ENTERPRISE_INVITE_SUCCESS,
  RESEND_ENTERPRISE_INVITE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const resendEnterpriseInviteReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_ENTERPRISE_INVITE:
      return { ...state, loading: true };
    case RESEND_ENTERPRISE_INVITE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case RESEND_ENTERPRISE_INVITE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default resendEnterpriseInviteReducer;
